import action from '../commons/scheduleActionStatus';

export const getScheduleEventRequestAction = () => {
    return {
        type: action.GET_EVENTS_REQUEST,
        status: 'GET_EVENTS_REQUEST',
        requestState: true,
    };
};

export const getScheduleEventSuccessAction = (result) => {
    return {
        type: action.GET_EVENTS_SUCCESS,
        status: 'Schedule Events retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getScheduleEventFailureAction = (error) => {
    return {
        type: action.GET_EVENTS_FAILURE,
        status: 'Schedule event retrieved failure',
        error,
        requestState: false,
    };
};


export const postScheduleEventRequestAction = (body) => {
    return {
        type: action.POST_EVENTS_REQUEST,
        status: 'POST_EVENTS_REQUEST',
        requestState: true,
        payload: {
            body
        }
    };
};

export const postScheduleEventSuccessAction = (result) => {
    return {
        type: action.POST_EVENTS_SUCCESS,
        status: action.POST_EVENTS_SUCCESS,
        result,
        requestState: false,
    };
};

export const postScheduleEventFailureAction = (error) => {
    return {
        type: action.POST_EVENTS_FAILURE,
        status: 'Schedule event Creation failure',
        error,
        requestState: false,
    };
};


export const updateScheduleEventDataRequestAction = (body, id) => {
    return {
        type: action.UPDATE_EVENTS_REQUEST,
        status: "UPDATE_EVENTS_REQUEST",
        requestState: true,
        payload: {
            body,
            id
        },
    };
};

export const updateScheduleEventDataSuccessAction = (result) => {
    return {
        type: action.UPDATE_EVENTS_SUCCESS,
        status: action.UPDATE_EVENTS_SUCCESS,
        result,
        requestState: false,
    };
};

export const updateScheduleEventDataFailureAction = (error) => {
    return {
        type: action.UPDATE_EVENTS_FAILURE,
        status: "update event failure",
        error,
        requestState: false,
    };
};


export const deleteScheduleEventRequestAction = (id) => {
    return {
        type: action.DELETE_EVENTS_REQUEST,
        status: "DELETE_EVENTS_REQUEST",
        requestState: true,
        payload: {
            id
        },
    };
};

export const deleteScheduleEventSuccessAction = (result) => {
    return {
        type: action.DELETE_EVENTS_SUCCESS,
        status: "DELETE_EVENTS_SUCCESS",
        result,
        requestState: false,
    };
};

export const deleteScheduleEventFailureAction = (error) => {
    return {
        type: action.DELETE_EVENTS_FAILURE,
        status: "DELETE event failure",
        error,
        requestState: false,
    };
};


export const getSlotSummaryRequestAction = (startDate, endDate, hospitalId) => {
    return {
        type: action.GET_SLOT_SUMMARY_REQUEST,
        status: 'GET_SLOT_SUMMARY_REQUEST',
        requestState: true,
        payload: {
            startDate, endDate, hospitalId
        },
    };
};

export const getSlotSummarySuccessAction = (result) => {
    return {
        type: action.GET_SLOT_SUMMARY_SUCCESS,
        status: 'Slot Summary retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getSlotSummaryFailureAction = (error) => {
    return {
        type: action.GET_SLOT_SUMMARY_FAILURE,
        status: 'Slot Summary retrieved failure',
        error,
        requestState: false,
    };
};


export const updateSlotDataRequestAction = (body, id) => {
    return {
        type: action.UPDATE_SLOT_SUMMARY__REQUEST,
        status: "UPDATE_SLOT_SUMMARY__REQUEST",
        requestState: true,
        payload: {
            body,
            id
        },
    };
};

export const updateSlotDataSuccessAction = (result) => {
    return {
        type: action.UPDATE_SLOT_SUMMARY__SUCCESS,
        status: action.UPDATE_SLOT_SUMMARY__SUCCESS,
        result,
        requestState: false,
    };
};

export const updateSlotDataFailureAction = (error) => {
    return {
        type: action.UPDATE_SLOT_SUMMARY__FAILURE,
        status: "update Slot failure",
        error,
        requestState: false,
    };
};


export const blockSlotForDayRequestAction = (body) => {
    return {
        type: action.BLOCK_SLOT_SUMMARY__REQUEST,
        status: "BLOCK_SLOT_SUMMARY__REQUEST",
        requestState: true,
        payload: {
            body,
        },
    };
};

export const blockSlotForDaySuccessAction = (result) => {
    return {
        type: action.BLOCK_SLOT_SUMMARY__SUCCESS,
        status: action.BLOCK_SLOT_SUMMARY__SUCCESS,
        result,
        requestState: false,
    };
};

export const blockSlotForDayFailureAction = (error) => {
    return {
        type: action.BLOCK_SLOT_SUMMARY__FAILURE,
        status: "Block Slot failure",
        error,
        requestState: false,
    };
};


export const getUnavailabilityRequestAction = () => {
    return {
        type: action.GET_UNAVAILABILITY_REQUEST,
        status: "GET_UNAVAILABILITY_REQUEST",
        requestState: true,
    };
};

export const getUnavailabilitySuccessAction = (result) => {
    return {
        type: action.GET_UNAVAILABILITY_SUCCESS,
        status: "Unavailable Slot retrieved sucessfully",
        result,
        requestState: false,
    };
};

export const getUnavailabilityFailureAction = (error) => {
    return {
        type: action.GET_UNAVAILABILITY_FAILURE,
        status: "Unavailable Slot retrieved failure",
        error,
        requestState: false,
    };
};


export const postUnavailabilityRequestAction = (body) => {
    return {
        type: action.POST_UNAVAILABILITY_REQUEST,
        status: "POST_UNAVAILABILITY_REQUEST",
        requestState: true,
        payload: {
            body
        }
    };
};

export const postUnavailabilitySuccessAction = (result) => {
    return {
        type: action.POST_UNAVAILABILITY_SUCCESS,
        status: "Unavailable Slot Created sucessfully",
        result,
        requestState: false,
    };
};

export const postUnavailabilityFailureAction = (error) => {
    return {
        type: action.POST_UNAVAILABILITY_FAILURE,
        status: "Unavailable Slot Creation failure",
        error,
        requestState: false,
    };
};



export const deleteUnavailabilityRequestAction = (id) => {
    return {
        type: action.DELETE_UNAVAILABILITY_REQUEST,
        status: "DELETE_UNAVAILABILITY_REQUEST",
        requestState: true,
        payload: {
            id
        },
    };
};

export const deleteUnavailabilitySuccessAction = (result) => {
    return {
        type: action.DELETE_UNAVAILABILITY_SUCCESS,
        status: "Delete Unavailability sucessfully",
        result,
        requestState: false,
    };
};

export const deleteUnavailabilityFailureAction = (error) => {
    return {
        type: action.DELETE_UNAVAILABILITY_FAILURE,
        status: "Delete Unavailability failure",
        error,
        requestState: false,
    };
};



export const getAvailabilityRequestAction = (hospitalId) => {
    return {
        type: action.GET_AVAILABILITY_REQUEST,
        status: "GET_AVAILABILITY_REQUEST",
        requestState: true,
        payload: { hospitalId },
    };
};

export const getAvailabilitySuccessAction = (result) => {
    return {
        type: action.GET_AVAILABILITY_SUCCESS,
        status: "Available Slot retrieved sucessfully",
        result,
        requestState: false,
    };
};

export const getAvailabilityFailureAction = (error) => {
    return {
        type: action.GET_UNAVAILABILITY_FAILURE,
        status: "Available Slot retrieved failure",
        error,
        requestState: false,
    };
};


export const postAvailabilityRequestAction = (body) => {
    return {
        type: action.POST_AVAILABILITY_REQUEST,
        status: "POST_AVAILABILITY_REQUEST",
        requestState: true,
        payload: {
            body
        }
    };
};

export const postAvailabilitySuccessAction = (result) => {
    return {
        type: action.POST_AVAILABILITY_SUCCESS,
        status: "Available Slot Created sucessfully",
        result,
        requestState: false,
    };
};

export const postAvailabilityFailureAction = (error) => {
    return {
        type: action.POST_AVAILABILITY_FAILURE,
        status: "Available Slot Creation failure",
        error,
        requestState: false,
    };
};



export const updateAvailabilityRequestAction = (body, id) => {
    return {
        type: action.UPDATE_AVAILABILITY_REQUEST,
        status: "UPDATE_AVAILABILITY_REQUEST",
        requestState: true,
        payload: {
            body,
            id
        },
    };
};

export const updateAvailabilitySuccessAction = (result) => {
    return {
        type: action.UPDATE_AVAILABILITY_SUCCESS,
        status: "Slot Availability updated sucessfully",
        result,
        requestState: false,
    };
};

export const updateAvailabilityFailureAction = (error) => {
    return {
        type: action.UPDATE_AVAILABILITY_FAILURE,
        status: "update Slot Availability failure",
        error,
        requestState: false,
    };
};

export const moveBulkAppointmentForSlotRequestAction = (body) => {
    return {
        type: action.MOVE_BULK_APPOINTEMNTS_REQUEST,
        status: "MOVE_BULK_APPOINTEMNTS_REQUEST",
        requestState: true,
        payload: {
            body,
        },
    };
};

export const moveBulkAppointmentForSlotSuccessAction = (result) => {
    return {
        type: action.MOVE_BULK_APPOINTEMNTS_SUCCESS,
        status: action.MOVE_BULK_APPOINTEMNTS_SUCCESS,
        result,
        requestState: false,
    };
};

export const moveBulkAppointmentForSlotFailureAction = (error) => {
    return {
        type: action.MOVE_BULK_APPOINTEMNTS_FAILURE,
        status: "MOVING BULK APPOINTMENTS failure",
        error,
        requestState: false,
    };
};

export const unblockSlotForDayRequestAction = (body) => {
    return {
        type: action.UNBLOCK_SLOT_SUMMARY_REQUEST,
        status: "UNBLOCK_SLOT_SUMMARY_REQUEST",
        requestState: true,
        payload: {
            body,
        },
    };
};

export const unblockSlotForDaySuccessAction = (result) => {
    return {
        type: action.UNBLOCK_SLOT_SUMMARY_SUCCESS,
        status: action.UNBLOCK_SLOT_SUMMARY_SUCCESS,
        result,
        requestState: false,
    };
};

export const unblockSlotForDayFailureAction = (error) => {
    return {
        type: action.UNBLOCK_SLOT_SUMMARY_FAILURE,
        status: "Block Slot failure",
        error,
        requestState: false,
    };
};

export const cancelBulkAppointmentRequestAction = (id) => {
    return {
        type: action.CANCEL_BULK_APPOINTMENTS_REQUEST,
        status: "CANCEL_BULK_APPOINTMENTS_REQUEST",
        requestState: true,
        payload: {
            id
        },
    };
};

export const cancelBulkAppointmentSuccessAction = (result) => {
    return {
        type: action.CANCEL_BULK_APPOINTMENTS_SUCCESS,
        status: "CANCEL_BULK_APPOINTMENTS_SUCCESS",
        result,
        requestState: false,
    };
};

export const cancelBulkAppointmentFailureAction = (error) => {
    return {
        type: action.CANCEL_BULK_APPOINTMENTS_FAILURE,
        status: "cancel bulk appointment failure",
        error,
        requestState: false,
    };
};

export const getTimelineRequestAction = (hospitalId) => {
    return {
        type: action.GET_TIMELINE_REQUEST,
        status: 'GET_TIMELINE_REQUEST',
        requestState: true,
        payload: {
            hospitalId
        },
    };
};

export const getTimelineSuccessAction = (result) => {
    return {
        type: action.GET_TIMELINE_SUCCESS,
        status: 'TIMELINE retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getTimelineFailureAction = (error) => {
    return {
        type: action.GET_TIMELINE_FAILURE,
        status: 'TIMELINE retrieval failure',
        error,
        requestState: false,
    };
};
